/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import slugify from 'slugify'
import Input from 'components/Input'
import BaseModal from 'components/Modals/BaseModal'
import * as classes from './styles'

export type Item = {
  slug: string
  title: string
  index: number
}

export type EditItemModalProps = {
  item: Item | null
  onClose: () => void
  onSubmit: (item: Item) => void
  validateSlug: (slug: string, isNew?: boolean) => string | undefined
  validateTitle: (title: string, isNew?: boolean) => string | undefined
}

export const EditItemModal = ({ item, onClose, onSubmit, validateSlug, validateTitle }: EditItemModalProps) => {
  const [newSlug, setNewSlug] = useState(item?.slug ?? '')
  const [newTitle, setNewTitle] = useState(item?.title ?? '')

  useEffect(() => {
    if (item) {
      setNewSlug(item.slug)
      setNewTitle(item.title)
    }
  }, [item])

  const newSlugError = validateSlug(newSlug, item?.slug !== newSlug)
  const newTitleError = validateTitle(newTitle, item?.title !== newTitle)

  const handleSlugChange = (slug: string) => setNewSlug(slugify(slug, { lower: true }))

  const handleSubmit = () => {
    if (!item || newSlugError || newTitleError) {
      return
    }

    onSubmit({
      ...item,
      slug: newSlug,
      title: newTitle,
    })
  }

  return (
    <BaseModal open={!!item} onClose={onClose}>
      <Typography css={classes.title} variant="title2">
        Edit Table of Content Item #{(item?.index ?? 0) + 1}
      </Typography>
      <Input
        value={newTitle}
        onChange={setNewTitle}
        label="Title"
        placeholder={item?.title}
        error={!!newTitleError}
        formHelperText={newTitleError}
        fullWidth
      />
      <Input
        value={newSlug}
        onChange={handleSlugChange}
        label="Slug"
        placeholder={item?.slug}
        error={!!newSlugError}
        formHelperText={newSlugError}
        fullWidth
      />
      <Button variant="contained" color="blue" fullWidth size="large" onClick={handleSubmit}>
        Update
      </Button>
      <Button variant="outlined" color="blue" fullWidth size="large" onClick={onClose}>
        Cancel
      </Button>
    </BaseModal>
  )
}
